import type {
  AccountResponse,
  AccountType,
  BalanceSheetResponse,
  CreateAccountRequest,
  FundBalancesResponse,
  IncomeStatementResponse,
  JournalEntryLineInput,
  JournalEntryResponse,
  LedgerLineResponse,
  PaginatedResponse,
  PostJournalEntryRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export interface ListJournalEntriesParams {
  readonly accountId?: string | undefined;
  readonly limit?: number | undefined;
}

export const financeApi = {
  listAccounts() {
    return apiRequest<readonly AccountResponse[]>('/finance/accounts');
  },

  createAccount(body: CreateAccountRequest) {
    return apiRequest<AccountResponse>('/finance/accounts', { method: 'POST', body });
  },

  getAccountLedger(accountId: string) {
    return apiRequest<readonly LedgerLineResponse[]>(`/finance/accounts/${accountId}/ledger`);
  },

  listJournalEntries(params: ListJournalEntriesParams = {}, signal?: AbortSignal) {
    return apiRequest<PaginatedResponse<JournalEntryResponse>>('/finance/journal-entries', {
      query: { ...params },
      signal,
    });
  },

  postJournalEntry(body: PostJournalEntryRequest) {
    return apiRequest<JournalEntryResponse>('/finance/journal-entries', { method: 'POST', body });
  },

  getIncomeStatement(from: string, to: string, signal?: AbortSignal) {
    return apiRequest<IncomeStatementResponse>('/finance/reports/income-statement', {
      query: { from, to },
      signal,
    });
  },

  getFundBalances(from: string, to: string, signal?: AbortSignal) {
    return apiRequest<FundBalancesResponse>('/finance/reports/fund-balances', {
      query: { from, to },
      signal,
    });
  },

  getBalanceSheet(asOf: string, signal?: AbortSignal) {
    return apiRequest<BalanceSheetResponse>('/finance/reports/balance-sheet', {
      query: { asOf },
      signal,
    });
  },
};

export type { AccountType, JournalEntryLineInput };
